import { BaseElements, BaseObject, BaseService, BaseInjector } from '../../js/base';
import { querySelector } from '../../utility/utils';
import { EmptyNodeList } from '../../utility/utils/index';

class Texts extends BaseObject {}

class ClassList extends BaseObject {

}

class Selectors extends BaseObject {
    dialogCloseBtn = ".dialog-close";
    openDialogBtnExample = ".openDialogBtnExample"
}

class Elements extends BaseElements<Selectors> {
    dialogCloseBtn: NodeListOf<HTMLButtonElement> = new EmptyNodeList();
    openDialogBtnExample: HTMLButtonElement;

    constructor(selectors: Selectors) {
        super(selectors, false);
    }

    setWrapper(wrapper: HTMLElement) {
        this.wrapper = wrapper;
        this.initElements()
    }

    // Loop over all elements and init them
    initElements() {
        this.initElementsByLoop(this.wrapper);
        this.openDialogBtnExample = querySelector(this.selectors.openDialogBtnExample);
    }
}

interface Dialog extends BaseService<Selectors, Elements, ClassList, Texts> { }

@BaseInjector(Selectors, Elements, ClassList, Texts)
class Dialog {
    focusables: Array<HTMLElement> = [];

    constructor(protected readonly wrapper: any) {}

    initialize(): void {
        this.elements.setWrapper(this.wrapper);
        this.addEventListeners();      
    }

    addEventListeners(): void {
        if(this.elements.openDialogBtnExample) {
            this.elements.openDialogBtnExample.addEventListener('click' , ()=> {
                this.showModalHandler(this.wrapper);
            })
        }

        // add close functionality to close button
        this.elements.dialogCloseBtn.forEach(button =>{
            button.addEventListener('click' , ()=> {
                this.closeModalHandler(this.wrapper);
            })
        })

        // Create Observer 
        this.createObserver();

        this.onOpenHandler();

        this.wrapper.addEventListener('keydown', (event: any) => {
            this.focusTrapHandler(event);
        });
    }

    showModalHandler(wrapper : any) {
        wrapper.showModal();
    }

    closeModalHandler(wrapper : any) {
        wrapper.close();
    }

    createObserver() {
        const ObserverM = new MutationObserver( recs => {
            recs.forEach( ({attributeName: attr, target: dial }) => {
                let observedDialog = dial as any;
                if (attr === 'open' && observedDialog.open ) {
                    observedDialog.onOpen();
                } // call onOpen Method...  
            })
        });
        ObserverM.observe( this.wrapper , { attributes: true })
    }

    onOpenHandler() {
        this.wrapper.onOpen = () => {
            this.focusables = Array.from(this.wrapper.querySelectorAll(
                'input, button, select, textarea, a[href]'
            ));
            this.elements.dialogCloseBtn[0]?.focus();
        }
    }

    focusTrapHandler(event: any) {
        // Trap the focus within the dialog when the Tab key is pressed
        if (event.key === 'Tab') {
            const firstFocusable = this.focusables[0];
            const lastFocusable = this.focusables[this.focusables.length - 1];
        
            if (event.shiftKey) {
                // Shift + Tab: Move focus to the previous element within the dialog
                if (document.activeElement === firstFocusable) {
                    event.preventDefault();
                    lastFocusable.focus();
                }
            } else {
                // Tab: Move focus to the next element within the dialog
                if (document.activeElement === lastFocusable) {
                    event.preventDefault();
                    firstFocusable.focus();
                }
            }
        }
    }
}

export default Dialog;

export {
    Elements as DialogElements,
    Selectors as DialogSelectors,
    ClassList as DialogClassList,
    Texts as DialogTexts
}